import { Button, Icon } from '@material-ui/core';
import CropperJS from 'cropperjs';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext("2d");

  const pixelRatio = window.devicePixelRatio;
  canvas.width = crop.width * pixelRatio;
  canvas.height = crop.height * pixelRatio;
  ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          blob.name = fileName;
        }
        resolve(blob);
      },
      "image/png",
      1
    );
  });
}

class ImageSelect extends Component {
    state = {
      saving: false,
      modalOpen: false, // Novo estado para controlar a abertura da modal
      aspect: 1,
      unit: '%',
      width: 100,
      height: 100
    };
  
    setSaving = (saving) => {
      this.setState({ saving });
    };
  
    setModalOpen = (modalOpen) => {
      this.setState({ modalOpen });
    };

  static defaultProps = {
    id: 'image-select',
    maxWidth: 200,
    maxHeight: null,
    image: null,
    selectText: 'Select a photo',
    cleanText: 'Clean',
    changeText: 'Change photo',
    showCrop: false,
    onCleanImage: () => { },
    onChangeImage: () => { }
  }

  static propTypes = {
    id: PropTypes.string,
    selectText: PropTypes.string,
    cleanText: PropTypes.string,
    changeText: PropTypes.string,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    image: PropTypes.string,
    showCrop: PropTypes.bool,
    onCleanImage: PropTypes.func.isRequired,
    onCompleteCrop: PropTypes.func,
    onChangeImage: PropTypes.func.isRequired
  }

  componentDidUpdate(prevProps) {
    const { image, position, onCompleteCrop } = this.props;
    const imageElement = this.imageRef;

    if (image !== prevProps.image && image && imageElement) {
      // Abrir a modal ao receber uma nova imagem
      this.setModalOpen(true);
    }

    if (image && imageElement && this.state.modalOpen) {
      const onImageCropped = (cropper) => {
        cropper.getCroppedCanvas().toBlob((blob) => {
          onCompleteCrop(blob);
        });
        this.setSaving(false);
      };

      let cropperOptions = {
        ready() {
          onImageCropped(cropper);
        },
        cropend() {
          onImageCropped(cropper);
        },
      };

      if (position === 1) {
        cropperOptions.aspectRatio = 1;
      } else if (position === 2) {
        cropperOptions.dragMode = 'move';
      }

      const cropper = new CropperJS(imageElement, cropperOptions);
      this.cropper = cropper;
    }
  }

  render() {
    const {
      image,
      maxWidth,
      maxHeight,
      selectText,
      cleanText,
      changeText,
      style,
      onCleanImage,
      onCompleteCrop,
      onChangeImage
    } = this.props;
    const { saving, modalOpen } = this.state;

    if (image) {
      return (
        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', ...style }}>
          <img ref={ref => this.imageRef = ref} src={image} alt="Selector" style={{ maxWidth: maxWidth, maxHeight: maxHeight ? maxHeight : "inherit" }} />
          <input ref={ref => this.fileInput = ref} onChange={(evt) => {
            if (this.cropper) {
              this.setSaving(true);
              this.cropper.getCroppedCanvas().toBlob((blob) => {
                onCompleteCrop(blob);
              });
            }
            onChangeImage(evt);
          }} type="file" accept="image/*" id="file-input" name="file-input"
            style={{ display: 'none' }} />
          <br />
          <label htmlFor="file-input">
            <Button onClick={() => this.fileInput.click()} variant="contained" color="secondary" disabled={saving || modalOpen}>
              <Icon style={{ marginRight: 15 }}>autorenew</Icon> {changeText}
            </Button>
            <Button onClick={onCleanImage}><Icon style={{ marginRight: 15 }}>close</Icon> {cleanText}</Button>
          </label>
        </div>
      );
    }

    return (
      <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', ...style }}>
        <input ref={ref => this.fileInput = ref} onChange={onChangeImage} type="file" accept="image/*" id="file-input" name="file-input"
          style={{ display: 'none' }} />
        <br />
        <label htmlFor="file-input">
          <Button onClick={() => {
            this.setModalOpen(true);
            this.fileInput.click();
          }} variant="contained" color="secondary" disabled={saving || modalOpen}>
            <Icon style={{ marginRight: 15 }}>image_gallery</Icon> {selectText}
          </Button>
        </label>
      </div>
    );
  }
}

export default ImageSelect;